import RoleService from '@/shared/services/RoleService'
import { useQuery } from '@tanstack/react-query'
import { roleQueryKeys } from '../keys/role.query-keys'

export const useRoleTabs = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: roleQueryKeys.tabs(),
    queryFn: () => RoleService.getListTab(),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: options?.enabled,
  })
